import { render, staticRenderFns } from "./SlidList.vue?vue&type=template&id=3d187b1c&scoped=true"
import script from "./SlidList.vue?vue&type=script&lang=js"
export * from "./SlidList.vue?vue&type=script&lang=js"
import style0 from "./SlidList.vue?vue&type=style&index=0&id=3d187b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d187b1c",
  null
  
)

export default component.exports